import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TeamService} from '@core/services/team.service';
import { EventsHttpService, EventsOrderType } from '@api/http/events/events-http.service';
import { Event } from '@api/models/event/event';
import { Subscription } from 'rxjs';
import { UserService } from '@app/core/services/user.service';
import { User } from '@app/shared/models/user';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'app-team-matches',
  templateUrl: './team-matches.component.html',
  styleUrls: ['./team-matches.component.scss'],
})

export class TeamMatchesComponent implements OnInit, OnDestroy {
  public upcomingSelected = false;
  public loading = false;
  public user: User;
  public totalCount = 0;
  public games: Event[] = [];
  private pastGames: Event[] = [];
  private upcomingGames: Event[] = [];
  private teamId: string;
  private limit = 10;
  private user$: Subscription;

  constructor( private teamService: TeamService,
               private userService: UserService,
               private activatedRoute: ActivatedRoute,
               private eventsHttp: EventsHttpService ) { }

  public ngOnInit(): void {
    this.teamId = this.teamService.getCurrentTeamId();
    this.user$ = this.userService.currentUserSubject.subscribe(user => {
      if (this.user?._id === user?._id) {
        return;
      }
      this.user = user;
    })
    this.onTabChange(this.activatedRoute.snapshot.data.future);
  }

  public ngOnDestroy(): void {
    this.user$?.unsubscribe();
  }

  public onTabChange(upcoming = true): void {
    this.upcomingSelected = upcoming;
    this.upcomingSelected ? this.loadUpcomingGames() : this.loadPastGames();
  }

  private async loadUpcomingGames(): Promise<void> {
    try {
      this.loading = this.upcomingGames.length === 0;
      const limit = this.upcomingGames.length > 0 ? this.upcomingGames.length : this.limit;
      const response = await this.eventsHttp.getEventsForTeamPaginated(
        this.teamId, EventsOrderType.Future, 0, limit
      );
      this.upcomingGames = response.data;
      this.games = response.data;
      this.totalCount = response.total_count;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  private async loadPastGames(): Promise<void> {
    try {
      this.loading = this.pastGames.length === 0;
      const limit = this.pastGames.length > 0 ? this.pastGames.length : this.limit;
      const response = await this.eventsHttp.getEventsForTeamPaginated(
        this.teamId, EventsOrderType.Past, 0, limit
      );
      this.pastGames = response.data;
      this.games = response.data;
      this.totalCount = response.total_count;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  public loadMore(): void {
    this.upcomingSelected ? this.loadMoreUpcomingGames() : this.loadMorePastGames();
  }

  private async loadMoreUpcomingGames(): Promise<void> {
    try {
      const response = await this.eventsHttp.getEventsForTeamPaginated(
        this.teamId, EventsOrderType.Future, this.upcomingGames.length, this.limit
      );
      this.upcomingGames = this.upcomingGames.concat(response.data);
      this.games = this.upcomingGames;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }

  private async loadMorePastGames(): Promise<void> {
    try {
      const response = await this.eventsHttp.getEventsForTeamPaginated(
        this.teamId, EventsOrderType.Past, this.pastGames.length, this.limit
      );
      this.pastGames = this.pastGames.concat(response.data);
      this.games = this.pastGames;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      throw e;
    }
  }
}
